import { TagDto } from './tag.dto';

export class ConversationBatchTaggingDto {
  startTime: Date;
  endTime: Date;
  tags: TagDto[] = [];
  criteriaType: number;
  attachedDataId: number;
  file: File;
}
